var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "max-w-lg w-full bg-black text-white p-4 mb-3 md:mb-12 flex flex-wrap border-l-24 border-red",
    },
    [
      _c("div", { staticClass: "pr-4 mb-3 md:mb-0 w-full" }, [
        _c("p", [
          _vm._v(
            "\n      We noticed this festival is using the older date functionality.\n      Would you like to convert it over to use the new setup?\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pt-4" }, [
          _c(
            "button",
            {
              staticClass:
                "px-3 py-2 text-black font-sans-bold text-center inline-block bg-white uppercase no-underline font-bold",
              attrs: { disabled: _vm.loading },
              on: { click: _vm.convertFestival },
            },
            [
              !_vm.loading
                ? _c("span", [_vm._v("\n          Convert\n        ")])
                : _c("span", { staticClass: "italic" }, [
                    _vm._v("\n          Converting now...\n        "),
                  ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }